import {
  useAppointmentPermissions,
  type AppointmentPermissions,
} from '@erp/appointments/hooks/useAppointmentPermissions';

/**
 * Objetivo: Proveer permisos específicos para la pantalla de historias clínicas.
 * Entradas: Ninguna (usa el hook de appointments subyacente).
 * Salidas: Objeto con permisos calculados para historias clínicas.
 * Requerimientos:
 *   - Reutilizar la lógica de permisos de appointments
 *   - canViewHistory: permite ver el listado y drawer
 *   - canManageHistory: permite crear evoluciones
 */
export interface ClinicalHistoryPermissions extends AppointmentPermissions {
  canViewClinicalHistory: boolean;
  canManageClinicalHistory: boolean;
  restrictToOwnClinicalHistory: boolean;
}

export const useClinicalHistoryPermissions = (): ClinicalHistoryPermissions => {
  const appointmentPerms = useAppointmentPermissions();

  return {
    ...appointmentPerms,
    canViewClinicalHistory: appointmentPerms.canViewHistory,
    canManageClinicalHistory: appointmentPerms.canManageHistory,
    restrictToOwnClinicalHistory: appointmentPerms.restrictToOwnHistory,
  };
};
